import { Controller } from "react-hook-form";
import { FormLabel } from "../FormLabel";
import { Select } from "../Select";
import { FormErrorLabel } from "../FormErrorLabel";

const FormSelect = ({
  name,
  label,
  control,
  error,
  isRequired,
  options,
  onChange: onSelectChange,
  ...rest
}: any) => {
  return (
    <div className="relative flex flex-col items-start gap-1">
      {label && (
        <FormLabel>
          {label} <span className="text-red-700">{isRequired ? "*" : ""}</span>
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <Select
              options={options}
              {...field}
              {...rest}
              value={field.value?.toString()}
              defaultValue={field.value?.toString()}
              onChange={(value: any) => {
                onSelectChange && onSelectChange(value);
                field.onChange(value);
              }}
            />
          );
        }}
      />
      {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};

export default FormSelect;
